<template>
  <div class="job-card">
    <step :status="stepMapAudit[cardInfo.audit_status]" />

    <div class="main">
      <!-- 图片上传 -->
      <template v-if="stepMapAudit[cardInfo.audit_status] == 0">
        <div class="upload-image-eg">
          <div class="example">
            <div class="photo-eg">
              <p class="eg-title">照片示例：</p>
              <img class="eg-image" src="@/assets/icon/photo-eg.png" alt />
            </div>
            <img class="eg-arrow" src="@/assets/icon/eg-arrow.png" alt />
            <div class="job-card-eg">
              <p class="eg-title">工卡示例：</p>
              <img class="card-eg" src="@/assets/icon/card-eg.png" alt />
            </div>
          </div>
          <p class="eg-title">工卡照片要求：</p>
          <ol>
            <li>1.白底、单人半身近照（最低位置为腰部以上）；商务形象照/半身职业照将大大提升工牌颜值哟；</li>
            <li>2.像素质量：1M~5M，不低于1M大小；</li>
            <li>3.照片格式：支持jpg、png格式；</li>
            <li>4.照片不可以遮挡面部，不支持1寸/2寸类的大头证件照片；</li>
            <li class="ps">
              PS：不符合要求的照片会被驳回重新提交哦~有问题可飞书咨询
              行政小客服。
            </li>
          </ol>
        </div>
        <el-button type="primary" @click="showUploadPhoto">上传照片</el-button>
      </template>

      <!-- 审核中-->
      <template v-if="stepMapAudit[cardInfo.audit_status] != 0">
        <div class="image-checked">
          <p class="tip-desc">
            帮助说明
            <span>{{ stepTips[cardInfo.audit_status] }}</span>
          </p>
          <div class="photo-preview">
            <p class="preview-title">照片预览：</p>

            <el-image
              class="preview-image"
              :src="cardInfo.card_img"
              :preview-src-list="[cardInfo.card_img]"
              ref="previewImage"
            ></el-image>

            <el-button
              type="text"
              class="look-large"
              icon="el-icon-zoom-in"
              @click="handlePreviewImage"
            >查看大图</el-button>
          </div>

          <el-button
            v-if="[2, 4].indexOf(cardInfo.audit_status) == -1"
            type="primary"
            @click="showUploadPhoto"
          >重新上传</el-button>

          <p class="tip">如遇问题，可飞书联系“行政小客服”</p>
        </div>
      </template>
    </div>
    <input
      type="file"
      v-show="false"
      ref="fileinput"
      accept=".jpg, .jpeg, .png, .gif"
      @change="handleChange"
    />

    <upload-photo ref="uploadPhoto" @uploadSuccess="getJobCardInfo" />
  </div>
</template>

<script>
import uploadPhoto from "./upload-photo.vue";
import step from "./step.vue";
import { mapGetters } from "vuex";

export default {
  name: "add",
  components: {
    step,
    uploadPhoto
  },
  data() {
    return {
      cardInfo: {
        id: "",
        card_img: "", // 工卡图片地址
        uid: "",
        uname: "",
        depart_path: "", // 部门
        user_mail: "",
        audit_status: 0, // 1-待审核 2-通过 3-不通过 4-工卡制作完成 5-补办
        apply_count: 1, // 申请办理次数
        remark: "" // 备注
      },
      // 0 上传照片 1 审核中 2 审核通过，工卡制作中 3 工卡制作完成
      stepMapAudit: {
        0: 0,
        1: 1,
        2: 2,
        3: 1,
        4: 3,
        5: 0
      },
      stepTips: [
        ,
        "照片已上传完成，后台正在审核中",
        "照片已审核通过，请耐心等待工卡制作",
        "照片审核未通过，请重新上传",
        "工卡制作完成"
      ]
    };
  },

  methods: {
    getJobCardInfo() {
      _api.personal.getCard().then(res => {
        if (res.data.detail && Object.keys(res.data.detail).length > 0) {
          this.cardInfo = Object.assign(this.cardInfo, res.data.detail);
          this.cardInfo.card_img =
            this.cardInfo.card_img + "?temp=" + new Date().getTime();
        }
      });
    },
    showUploadPhoto() {
      this.$refs.fileinput.click();
    },
    handleChange(e) {
      console.log(e.target.value);
      if (this.$refs.fileinput) this.$refs.uploadPhoto.visbility = true;
      this.$refs.uploadPhoto.handleChange(e);
      e.target.value = "";
    },

    handlePreviewImage() {
      this.$refs.previewImage.showViewer = true;
    }
  },
  created() {
    this.getJobCardInfo();
  }
};
</script>

<style lang="scss" scoped>
.job-card {
  padding-top: 15px;
  /deep/ .el-icon-circle-close {
    color: #fff !important;
  }
}

.main {
  width: 681px;
  margin: 0 auto;
  .el-button--primary {
    width: 98px;
    height: 33px;
    border-radius: 3px;
    background-color: rgba(66, 114, 171, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    padding: 0;
  }
}
.upload-image-eg {
  width: 100%;
  height: 462px;
  background-color: rgba(248, 248, 248, 1);

  padding: 22px 64px 24px 38px;
  box-sizing: border-box;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 27px;
}
.tip-desc {
  padding-bottom: 8px;
  position: relative;
  font-weight: 500;
  line-height: 14px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-image: linear-gradient(
      to right,
      #c2d0e1 0%,
      #c2d0e1 50%,
      #f8f8f8 50%
    );
    background-size: 18px 2px;
    background-repeat: repeat-x;
  }
}

.example {
  display: flex;
  margin-bottom: 20px;
}
.eg-title {
  & ~ ol {
    margin-top: 8px;

    li {
      white-space: nowrap;
    }
  }
}

.eg-image {
  width: 170px;
  height: 220px;
  margin-top: 8px;
}

.eg-arrow {
  width: 54px;
  height: 44px;
  align-self: center;
  margin-right: 86px;
  margin-left: 76px;
}
.ps {
  margin-top: 12px;
  line-height: 14px;
}

.tip {
  margin-top: 10px;
  color: #999;
  font-size: 14px;
  margin-left: 38px;
}
.card-eg {
  width: 144px;
  height: 226px;
  margin-top: 7px;
}
.card-desc {
  color: #666666;
  margin-top: 6px;
}

.image-checked {
  .tip-desc {
    width: 100%;
    height: 59px;
    padding-left: 38px;
    box-sizing: border-box;
    line-height: 59px;
    color: #333333;
    font-weight: 600;
    background-color: rgba(248, 248, 248, 1);
    margin-bottom: 56px;
    padding-bottom: 0;
    span {
      font-weight: normal;
      margin-left: 15px;
      color: #999999;
    }
    &::after {
      display: none;
    }
  }

  .preview-title {
    height: 20px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    margin-bottom: 9px;
  }
  .photo-preview {
    margin-left: 38px;
  }
  .preview-image {
    width: 134px;
    height: auto;
    display: block;
  }

  /deep/ .el-image__preview {
    pointer-events: none;
    cursor: auto;
  }
  /deep/ .look-large {
    width: 134px;
    text-align: right;
    [class*="el-icon-"] + span {
      margin: 0;
    }
  }
  /deep/ .el-button--primary {
    margin-left: 38px;
  }
}
</style>
